import { render } from "./selectRelationshipContactLabel.vue?vue&type=template&id=7263aa12"
import script from "./selectRelationshipContactLabel.vue?vue&type=script&lang=js"
export * from "./selectRelationshipContactLabel.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__